import script from "./StudentDashboardView2.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDashboardView2.vue?vue&type=script&setup=true&lang=js"

import "./StudentDashboardView2.vue?vue&type=style&index=0&id=17c67255&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c67255"]])

export default __exports__